// Preserve the queue's screen position as well as its own internal scroll offset.
// Cards above it keep their natural height and all their text remains visible.
export function captureQueuePageAnchor(scroller, viewport) {
  if (!scroller) return null;
  const bounds = scroller.getBoundingClientRect();
  if (bounds.bottom <= 0 || bounds.top >= viewport.innerHeight) return null;
  return { top: bounds.top };
}

export function restoreQueuePageAnchor(scroller, viewport, anchor) {
  // Measure the remaining shift: the browser may already have anchored or clamped
  // its scroll position while applying a shorter document.
  if (!scroller || !anchor) return;
  const shift = scroller.getBoundingClientRect().top - anchor.top;
  if (Math.abs(shift) < 1) return;
  viewport.scrollBy({ top: shift, left: 0, behavior: "instant" });
}

export function captureQueueAnchor(scroller, items) {
  if (!scroller || !items?.length) {
    return null;
  }
  const viewportTop = scroller.getBoundingClientRect().top + scroller.clientTop;
  const viewportBottom = viewportTop + scroller.clientHeight;
  const row = Array.from(scroller.querySelectorAll("[data-queue-item-id]"))
    .find((element) => {
      const bounds = element.getBoundingClientRect();
      return bounds.bottom > viewportTop && bounds.top < viewportBottom;
    });
  if (!row) {
    return null;
  }
  const ids = items.map((item) => item.id);
  const index = ids.indexOf(row.dataset.queueItemId);
  return index < 0 ? null : {
    ids,
    index,
    offset: row.getBoundingClientRect().top - viewportTop,
  };
}

export function resolveQueueAnchor(anchor, items, movedItemIds = []) {
  if (!anchor || !items?.length) {
    return null;
  }
  const indices = new Map(items.map((item, index) => [item.id, index]));
  const movedIds = new Set(movedItemIds);
  // Stay beside the remaining rows instead of following an item the operator moved.
  // Prefer the same row, then the nearest survivor; ties favour the following row.
  for (let distance = 0; distance < anchor.ids.length; distance++) {
    for (const oldIndex of [anchor.index + distance, anchor.index - distance]) {
      const id = anchor.ids[oldIndex];
      if (indices.has(id) && !movedIds.has(id)) {
        return { id, index: indices.get(id), offset: anchor.offset };
      }
    }
  }
  return null;
}
